/**
 * Check if the URL is a private URL
 * @param url
 *
 * Capability routes: the token in the path is the credential, so they need no DPoP proof. The
 * backend keeps the same list independently (`DPOP_EXEMPT_PATH_PREFIXES` in `AuthFilter.java`) —
 * a pattern added here but not there 401s inside an `<img>`, where there is no error to catch.
 */
export const isPrivateURL = (url?: string) =>
  url?.includes('/download/__UNIFY_') ||
  url?.includes('/file/download/') ||
  url?.includes('/file/asset/download/');
